import { request } from '@/helpers/apiClient'
import { PRODUCT_OVERVIEW_CONFIG } from '@/utils/constants/apiConfig/ProductOverview/productOverviewConfig'

export const getProductOverview = id => request(PRODUCT_OVERVIEW_CONFIG.PRODUCT_TARGETS(id))

